import { Instance, types, getRoot, getSnapshot, applySnapshot } from 'mobx-state-tree'
import { IStore } from "../"
import { Plate as BusketPlate, IPlate } from "../busket"

const element = document.getElementById('goods');
let googds = element?.textContent || element?.innerText;
const n = googds?.lastIndexOf(",") as number;
googds = googds?.substring(0, n) as string + googds?.substring(n + 1);
let json: any

try { 
    json = JSON.parse(googds as string)
} catch(e){
    json = JSON.parse(`{"goods": [	{
    	"id": 1120,
        "type": 47,
		"img": "/upload/iblock/4f1/bcw0df11ny0rpa7ihxdv4s70pfq16es1.jpg",
		"name": "Номер подъезда",
		"price": "191.00",
		"size": "19 x 28.5 см"
	},
	{
    	"id": 1121,
        "type": 44,
		"img": "",
		"name": "Подъездная до 5 этажей",
		"price": "205.00",
		"size": "25 x 24 см"
	},
	{
    	"id": 986,
        "type": 53,
		"img": "/upload/iblock/100/7qpiqi7cjbadhffcgcagpdd2phod37gh.jpg",
		"name": "Подъездная от 6 до 14 этажей",
		"price": "318.00",
		"size": "25 x 41.5 см"
	},
	{
    	"id": 985,
        "type": 82,
		"img": "",
		"name": "Подъездная от 15 до 30 этажей",
		"price": "431.00",
		"size": "25 x 59 см"
	},
	{
    	"id": 1085,
        "type": 55,
		"img": "/upload/iblock/ae5/iv9ww50h0r3o8spggyky281a2f5i0xmt.jpg",
		"name": "Лифт",
		"price": "142.00",
		"size": "19 x 19 см"
	},
	{
    	"id": 1111,
        "type": 60,
		"img": "/upload/iblock/3e7/kwh9a48e8iug9vvz8sj2hyid4zw8as8v.jpg",
		"name": "Лифт грузовой",
		"price": "142.00",
		"size": "19 x 19 см"
	},
	{
    	"id": 1122,
        "type": 41,
		"img": "/upload/iblock/57f/5bnrosi8eb7vw8p3dimxunhykcklir6v.jpg",
		"name": "Правила пользования лифтом",
		"price": "191.00",
		"size": "19 x 28.5 см"
	},
	{
    	"id": 1110,
        "type": 56,
		"img": "/upload/iblock/cb5/5guirbbdzgxgosjiszjzg018w5h5epfl.jpg",
		"name": "Лестница",
		"price": "142.00",
		"size": "19 x 19 см"
	},
	{
    	"id": 984,
        "type": 80,
		"img": "/upload/iblock/22d/qrlgpmm7m1bo0nu261u6637llgx532w4.jpg",
		"name": "Выход влево",
		"price": "142.00",
		"size": "19 x 19 см"
	},
	{
    	"id": 1102,
        "type": 61,
		"img": "/upload/iblock/24b/dokexw12npicx0gwbaygvpzjgqjfkz32.jpg",
		"name": "Выход вправо",
		"price": "142.00",
		"size": "19 x 19 см"
	},
	{
    	"id": 987,
        "type": 40,
		"img": "/upload/iblock/0f8/721fs1ci1g4pg3r5r47aaqgwwh73d131.jpg",
		"name": "Стрелка влево",
		"price": "142.00",
		"size": "19 x 19 см"
	},
	{
    	"id": 1123,
        "type": 84,
		"img": "/upload/iblock/7ea/12h1fzfb20ezihbrbwhn5t1n4ft5gcvr.jpg",
		"name": "Стрелка вправо",
		"price": "142.00",
		"size": "19 x 19 см"
	},
	{
    	"id": 947,
        "type": 43,
		"img": "/upload/iblock/230/qpxk75bt4janko66cu3nwot3425euqb9.jpg",
		"name": "Квартиры на этаже",
		"price": "100.00",
		"size": "19 x 11 см"
	},
	{
    	"id": 948,
        "type": 46,
		"img": "/upload/iblock/247/yp6y68i292ytu6bx84cgs1mg38pgqhtq.jpg",
		"name": "Квартиры на этаже влево",
		"price": "100.00",
		"size": "19 x 11 см"
	},
	{
    	"id": 950,
        "type": 79,
		"img": "/upload/iblock/e45/e7up0qbkgw9qiichtl7p6ahzw9g0ylmj.jpg",
		"name": "Квартиры на этаже вправо",
		"price": "100.00",
		"size": "19 x 11 см"
	},
	{
    	"id": 1104,
        "type": 45,
		"img": "/upload/iblock/ce8/18bzija3iqg75tu8cm4xp2a8s7al4pwx.jpg",
		"name": "Квартиры на этаже влево/вправо",
		"price": "100.00",
		"size": "19 x 11 см"
	},
	{
    	"id": 1129,
        "type": 39,
		"img": "/upload/iblock/587/p7epxlxewnvn7w7v574pg3e1w9f96eqp.jpg",
		"name": "Этажная",
		"price": "191.00",
		"size": "19 x 28.5 см"
	},
	{
    	"id": 1113,
        "type": 81,
		"img": "/upload/iblock/7e5/u82o87rsei9nxwwn61rfx9b77srwk4d8.jpg",
		"name": "Номерок квартирный",
		"price": "43.00",
		"size": "7 x 5 см"
	},
	{
    	"id": 1114,
        "type": 51,
		"img": "/upload/iblock/877/5hua955mw6j3sffmxldz29ll5apagtsa.jpg",
		"name": "Номерок почтовый",
		"price": "35.00",
		"size": "6 x 3.5 см"
	},
	{
    	"id": 953,
        "type": 71,
		"img": "/upload/iblock/955/v90ekxy61hk0xx3csvf7zy27np38pd4j.jpg",
		"name": "Техническое помещение",
		"price": "100.00",
		"size": "19 x 11 см"
	},
	{
    	"id": 1100,
        "type": 62,
		"img": "/upload/iblock/c5c/o7z1vz8wtbbl1ksywlm2jtsnitwt9qf5.jpg",
		"name": "Видеонаблюдение",
		"price": "142.00",
		"size": "19 x 19 см"
	},
	{
    	"id": 1115,
        "type": 68,
		"img": "/upload/iblock/5e2/eh1jruzpjdl9etmj5hik9adag6l031ox.jpg",
		"name": "Охрана",
		"price": "142.00",
		"size": "19 x 19 см"
	},
	{
    	"id": 1105,
        "type": 57,
		"img": "/upload/iblock/044/301mn1oapqsv44tfp4fq234e79ba4dwx.jpg",
		"name": "Консьерж",
		"price": "142.00",
		"size": "19 x 19 см"
	},
	{
    	"id": 1116,
        "type": 77,
		"img": "/upload/iblock/31d/y1cfh4ktvrouul4kzg4uxx7ijnjyw9am.jpg",
		"name": "Парковка авто",
		"price": "142.00",
		"size": "19 x 19 см"
	},
	{
    	"id": 1119,
        "type": 48,
		"img": "/upload/iblock/234/49ni7p1nv71skc6d0gdjbbj0zgz6nftl.jpg",
		"name": "Парковочное место",
		"price": "142.00",
		"size": "19 x 19 см"
	},
	{
    	"id": 1118,
        "type": 49,
		"img": "/upload/iblock/a99/et4fi6lpnfr1t0zjm1pvgtah5doxwebk.jpg",
		"name": "Парковка запрещена",
		"price": "142.00",
		"size": "19 x 19 см"
	},
	{
    	"id": 1117,
        "type": 69,
		"img": "/upload/iblock/4b8/3t7efakugo0acrpba3jqdtsu06q665kl.jpg",
		"name": "Парковка велосипедная",
		"price": "142.00",
		"size": "19 x 19 см"
	},
	{
    	"id": 951,
        "type": 70,
		"img": "/upload/iblock/899/oetcwkx2pfroth0y9bbr615ghpfa0g1u.jpg",
		"name": "Парковка для колясок",
		"price": "142.00",
		"size": "19 x 19 см"
	},
	{
    	"id": 1103,
        "type": 59,
		"img": "/upload/iblock/c5e/amqtbqpac2nqxmswv9dcf2msfk5lois1.jpg",
		"name": "Детская площадка",
		"price": "142.00",
		"size": "19 x 19 см"
	},
	{
    	"id": 952,
        "type": 83,
		"img": "/upload/iblock/cc9/w3ygyvapxou48heofloi3cd5kmja17wf.jpg",
		"name": "Правила пользования детской площадкой",
		"price": "787.00",
		"size": "50 x 60 см"
	},
	{
    	"id": 1101,
        "type": 54,
		"img": "/upload/iblock/136/i8fpx2dojbm0k08vxrfosj1faae53092.jpg",
		"name": "Выгул животных",
		"price": "142.00",
		"size": "19 x 19 см"
	},
	{
    	"id": 946,
        "type": 78,
		"img": "/upload/iblock/655/vbn6ne2sqfgfwqyd2oiu12lfvttw8l3o.jpg",
		"name": "Выгул животных запрещён",
		"price": "142.00",
		"size": "19 x 19 см"
	},
	{
    	"id": 1112,
        "type": 52,
		"img": "/upload/iblock/d94/0xtgmbv1ezw2zuf971oh4stgaql1jlgz.jpg",
		"name": "Место для курения",
		"price": "142.00",
		"size": "19 x 19 см"
	},
	{
    	"id": 1106,
        "type": 50,
		"img": "/upload/iblock/5af/gepapaapbxxkycaoqytyxhb83euhaife.jpg",
		"name": "Курение запрещено",
		"price": "142.00",
		"size": "19 x 19 см"
	},
	{
    	"id": 1124,
        "type": 72,
		"img": "/upload/iblock/c54/sbnnb85ax6ktr7efn55rfb12o6jp131b.jpg",
		"name": "Стенд 2 кармана",
		"price": "612.00",
		"size": "50 x 45 см"
	},
	{
    	"id": 1125,
        "type": 73,
		"img": "/upload/iblock/0d7/jyspu7v10ckuiymqv40v8xso8153kqj1.jpg",
		"name": "Стенд 3 кармана",
		"price": "881.00",
		"size": "75 x 45 см"
	},
	{
    	"id": 1126,
        "type": 74,
		"img": "/upload/iblock/545/o63y9x380zuiena92a1twydzpg02qgbw.jpg",
		"name": "Стенд 4 кармана",
		"price": "1023.00",
		"size": "50 x 80 см"
	},
	{
    	"id": 1127,
        "type": 75,
		"img": "/upload/iblock/462/bff0e5othq3n9f3orxc05ob2ivhjy56c.jpg",
		"name": "Стенд 6 карманов",
		"price": "1470.00",
		"size": "75 x 80 см"
	},
	{
    	"id": 1128,
        "type": 76,
		"img": "/upload/iblock/cab/mv61ulum62u0hhyfra4qfa1s00j2yuoi.jpg",
		"name": "Стенд 8 карманов",
		"price": "1881.00",
		"size": "98 x 80 см"
	},
	{
    	"id": 1107,
        "type": 42,
		"img": "/upload/iblock/993/8ig3bvm98cotyvlr24849o6avg0hoem5.jpg",
		"name": "Ограничение скорости",
		"price": "361.00",
		"size": "⌀ 35"
	},
	{
    	"id": 1108,
        "type": 67,
		"img": "/upload/iblock/abc/o3e8lpmsyuu9d7dgxuiwcjc91ge0l6r9.jpg",
		"name": "Осторожно дети",
		"price": "361.00",
		"size": "35 x 35 см"
	},
	{
    	"id": 1109,
        "type": 58,
		"img": "/upload/iblock/854/6p4biaw30o9ll0p0hhiihamndpje5jus.jpg",
		"name": "Сигналить запрещено",
		"price": "361.00",
		"size": "⌀ 35"
	}
    ]
}`)
    console.log(e)
}


let floorNumberPlate = json.goods.find((el: any) => el.type === 39)
let flatNumberPlate = json.goods.find((el: any) => el.type === 43)
let flatsArraysPlate = json.goods.find((el: any) => el.type === 46)
let plateExit = json.goods.find((el: any) => el.type === 61)
let plateLift = json.goods.find((el: any) => el.type === 55)
let plateLiftGruz = json.goods.find((el: any) => el.type === 60)
let plateArrow = json.goods.find((el: any) => el.type === 40)
let plateStairs = json.goods.find((el: any) => el.type === 56)
let plateNoSmiring = json.goods.find((el: any) => el.type === 50)
let numberOnPostBox = json.goods.find((el: any) => el.type === 51)
let conciergePlate = json.goods.find((el: any) => el.type === 57)
let veloParkingPlate = json.goods.find((el: any) => el.type === 57)
let infostand2 = json.goods.find((el: any) => el.type === 72)
let infostand3 = json.goods.find((el: any) => el.type === 73)
let infostand4 = json.goods.find((el: any) => el.type === 74)
let infostand6 = json.goods.find((el: any) => el.type === 75)
let infostand8 = json.goods.find((el: any) => el.type === 76)
let listOfFloors = json.goods.find((el: any) => el.type === 55)
let cctv = json.goods.find((el: any) => el.type === 62)


const house = `
{ "housePlates":{
  "activeEntrance":1,
  "Entrances": [{
    "flatsOnFloors": 3,
    "floors": [{
    "flatsOnFloor": 3,
    "floorNumberPlate": {
      "id": "${floorNumberPlate.id}",
      "name": "${floorNumberPlate.name}",
      "img": "${floorNumberPlate.img}",
      "number": 0,
      "count": 0,
      "price": ${floorNumberPlate.price},
      "size": "${floorNumberPlate.size}"
    },
    "flatNumberPlate": {
      "id": "${flatNumberPlate.id}",
      "name": "${flatNumberPlate.name}",
      "img": "${flatNumberPlate.img}",
      "count": 1,
      "price": ${flatNumberPlate.price},
      "size": "${flatNumberPlate.size}"
    },
    "flatsArraysPlate": {
        "id": "${flatsArraysPlate.id}",
        "name": "${flatsArraysPlate.name}",
        "img": "${flatsArraysPlate.img}",
            "withArray": false, 
            "start": 1,
            "end": 3,
            "count": 1,
            "price": ${flatsArraysPlate.price},
            "size": "${flatsArraysPlate.size}"
    },
    "plateExit":{
        "id": "${plateExit.id}",
        "name": "${plateExit.name}",
        "img": "${plateExit.img}",
      "count": 1,
      "price": ${plateExit.price},
      "size": "${plateExit.size}"
    },
    "plateLift": {
        "id": "${plateLift.id}",
        "name": "${plateLift.name}",
        "img": "${plateLift.img}",
      "count": 1,
      "price": ${plateLift.price},
      "size": "${plateLift.size}"
    },
    "plateLiftGruz":{
        "id": "${plateLiftGruz.id}",
        "name": "${plateLiftGruz.name}",
        "img": "${plateLiftGruz.img}",
      "count": 1,
      "price": ${plateLiftGruz.price},
      "size": "${plateLiftGruz.size}"
    },
    "plateArrow": {
        "id": "${plateArrow.id}",
        "name": "${plateArrow.name}",
        "img": "${plateArrow.img}",
      "count": 1,
      "price": ${plateArrow.price},
      "size": "${plateArrow.size}"
    },
    "plateStairs": {
        "id": "${plateStairs.id}",
        "name": "${plateStairs.name}",
        "img": "${plateStairs.img}",
      "count": 1,
      "price": ${plateStairs.price},
      "size": "${plateStairs.size}"
    },
    "plateNoSmiring": {
        "id": "${plateNoSmiring.id}",
        "name": "${plateNoSmiring.name}",
        "img": "${plateNoSmiring.img}",
      "count": 1,
      "price": ${plateNoSmiring.price},
      "size": "${plateNoSmiring.size}"
    }
}],
    "informationStandOne": {
      "id": "${infostand2.id}",
      "name": "${infostand2.name}",
      "img": "${infostand2.img}",
      "count": 0,
      "price": ${infostand2.price},
      "size": "${infostand2.size}"
    },
    "informationStandTwo":  {
        "id": "${infostand3.id}",
        "name": "${infostand3.name}",
        "img": "${infostand3.img}",
        "count": 0,
        "price": ${infostand3.price},
        "size": "${infostand3.size}"
    },
    "informationStandTree": {
        "id": "${infostand4.id}",
        "name": "${infostand4.name}",
        "img": "${infostand4.img}",
        "count": 0,
        "price": ${infostand4.price},
        "size": "${infostand4.size}"
    },
    "informationStandFour":  {
        "id": "${infostand6.id}",
        "name": "${infostand6.name}",
        "img": "${infostand6.img}",
        "count": 0,
        "price": ${infostand6.price},
        "size": "${infostand6.size}"
    },
    "informationStandFive": {
        "id": "${infostand8.id}",
        "name": "${infostand8.name}",
        "img": "${infostand8.img}",
        "count": 0,
        "price": ${infostand8.price},
        "size": "${infostand8.size}"
    },
    "numberOnPostBox": {
        "id": "${numberOnPostBox.id}",
        "name": "${numberOnPostBox.name}",
        "img": "${numberOnPostBox.img}",
      "count": 1,
      "price": ${numberOnPostBox.price},
      "size": "${numberOnPostBox.size}"
    },
    "conciergePlate": {
        "id": "${conciergePlate.id}",
        "name": "${conciergePlate.name}",
        "img": "${conciergePlate.img}",
      "count": 1,
      "price": ${conciergePlate.price},
      "size": "${conciergePlate.size}"
    },
    "veloParkingPlate": {
        "id": "${veloParkingPlate.id}",
        "name": "${veloParkingPlate.name}",
        "img": "${veloParkingPlate.img}"
      "count": 1,
      "price": ${veloParkingPlate.price},
      "size": "${veloParkingPlate.size}"
    },
    "buggyPlate": {
        "id": "${plateNoSmiring.id}",
        "name": "${plateNoSmiring.name}",
        "img": "${plateNoSmiring.img}",
      "count": 1,
      "price": ${plateNoSmiring.price},
      "size": "${plateNoSmiring.size}"
    },
    "technicalRoomPlate": {
        "id": "${plateNoSmiring.id}",
        "name": "${plateNoSmiring.name}",
        "img": "${plateNoSmiring.img}",
      "count": 1,
      "price": ${plateNoSmiring.price},
      "size": "${plateNoSmiring.size}"
    },
    "floorListPlate": {
        "id": "${listOfFloors.id}",
        "name": "${listOfFloors.name}",
        "img": "${listOfFloors.img}",
      "count": 1,
      "price": ${listOfFloors.price},
      "size": "${listOfFloors.size}"
    },
    "cctvPlare": {
        "id": "${cctv.id}",
        "name": "${cctv.name}",
        "img": "${cctv.img}",
        "count": 1,
        "price": ${cctv.price},
        "size": "${cctv.size}"
    }
}]}}`

export const Plate = types
    .model("Plate", {
        id: types.maybeNull(types.string),
        name: types.maybeNull(types.string),
        img: types.maybeNull(types.string),
        size: types.maybeNull(types.string),
        countsOfComplects: 1,
        description: "",
        count: 0,
        price: 0,
    }).views(self => ({
        get fullPrice() {
            return self.count * self.price
        }
    }))

export const FloorNumberPlate = types
    .model("FloorNumberPlate", {
        id: types.maybeNull(types.string),
        name: types.maybeNull(types.string),
        img: types.maybeNull(types.string),
        size: types.maybeNull(types.string),
        number: 0,
        count: 0,
        price: 0,
    })

export const FlatsArraysPlate = types
    .model("FlatsArraysPlate", {
        id: types.maybeNull(types.string),
        name: types.maybeNull(types.string),
        img: types.maybeNull(types.string),
        size: types.maybeNull(types.string),
        withArray: false,
        midle: 0,
        start: 0,
        end: 0,
        count: 0,
        price: 0,
    })



const Floor = types
    .model('Floor', {
        flatsOnFloor: 0,
        floorNumberPlate: FloorNumberPlate,
        flatsArraysPlate: FlatsArraysPlate,
        flatNumberPlate: Plate,
        plateExit: Plate,
        plateLift: Plate,
        plateLiftGruz: Plate,
        plateArrow: Plate,
        plateStairs: Plate,
        plateNoSmiring: Plate
    })

const Entrance = types
    .model('Entrance', {
        flatsOnFloors: 3,
        floors: types.array(Floor),
        informationStandOne: Plate,
        informationStandTwo: Plate,
        informationStandTree: Plate,
        informationStandFour: Plate,
        informationStandFive: Plate,
        floorListPlate: Plate,
        numberOnPostBox: Plate,
        conciergePlate: Plate,
        veloParkingPlate: Plate,
        buggyPlate: Plate,
        technicalRoomPlate: Plate,
        cctvPlare: Plate
    }).views(self => ({
        get countOfFlats() {
            let count = 0
            self.floors.forEach(element => {
                count += element.flatsOnFloor
            });
            return count
        },
        get priceEntrance() {
            let result = 0
            self.floors.forEach(el => {
                result += el.floorNumberPlate.price + el.flatNumberPlate.price * el.flatsOnFloor + el.flatsArraysPlate.price +
                    el.plateExit.fullPrice + el.plateLift.fullPrice + el.plateLiftGruz.fullPrice + el.plateArrow.fullPrice + el.plateStairs.fullPrice + el.plateNoSmiring.fullPrice
            });
            return result
        }
    })).actions(self => ({
        changeExitCountPlates: (floor: number, count: number ) =>{
            self.floors[floor].plateExit.count = count
        },
        changeLiftCountPlates: (floor: number, count: number ) =>{
            self.floors[floor].plateLift.count = count
        },
        changeLiftGruzCountPlates: (floor: number, count: number ) =>{
            self.floors[floor].plateLiftGruz.count = count
        },
        changeArrowCountPlates: (floor: number, count: number ) =>{
            self.floors[floor].plateArrow.count = count
        },
        changeStairsCountPlates: (floor: number, count: number ) =>{
            self.floors[floor].plateStairs.count = count
        },
        changeNoSmoringCountPlates: (floor: number, count: number ) =>{
            self.floors[floor].plateNoSmiring.count = count
        },
        changeEntrPlateListPlate: (count: number) => {
            self.floorListPlate.count = count
        },
        changeNumberOnPostBoxPlateComplects: (count: number) => {
            self.floorListPlate.countsOfComplects = count
        },
        changeConciergePlateCount: (count: number) => {
            self.conciergePlate.count = count
        },
        changeVeloParkingPlateCount: (count: number) => {
            self.veloParkingPlate.count = count
        },
        changeBuggyPlateCount: (count: number) => {
            self.buggyPlate.count = count
        },
        changeTechnicalRoomPlateCount: (count: number) => {
            self.technicalRoomPlate.count = count
        },
        changeCCTVCount: (count: number) => {
            self.cctvPlare.count = count
        },
    })).views(self => ({
        get countsOfStands(){
            return self.informationStandOne.count + 
            self.informationStandTwo.count + 
            self.informationStandTree.count + 
            self.informationStandFour.count + 
            self.informationStandFive.count
        }
    }))
    .actions(self => ({
        addStand2: (count: number) => {
            if (count >= 0) {
                self.informationStandOne.count = count
            }
        },
        addStand3: (count: number) => {
            if (count >= 0) {
                self.informationStandTwo.count = count
            }
        },
        addStand4: (count: number) => {
            if (count >= 0) {
                self.informationStandTree.count = count
            }
        },
        addStand6: (count: number) => {
            if (count >= 0) {
                self.informationStandFour.count = count
            }
        },
        addStand8: (count: number) => {
            if (count >= 0) {
                self.informationStandFive.count = count
            }

        },
        bulkUpdatePlateExit: (isPlus: boolean) => {
            self.floors.forEach(element => {
                if (isPlus) {
                    element.plateExit.count++
                } else {
                    if (element.plateExit.count > 0) {
                        element.plateExit.count--
                    }
                }

            });
        },
        bulkUpdatePlateLift: (isPlus: boolean) => {
            self.floors.forEach(element => {
                if (isPlus) {
                    element.plateLift.count++
                } else {
                    if (element.plateLift.count > 0) {
                        element.plateLift.count--
                    }
                }
            });
        },
        bulkUpdatePlateLiftGruz: (isPlus: boolean) => {
            self.floors.forEach(element => {
                if (isPlus) {
                    element.plateLiftGruz.count++
                } else {
                    if (element.plateLiftGruz.count > 0 ) {
                        element.plateLiftGruz.count--
                    }
                }
            });
        },
        bulkUpdatePlateArrow: (isPlus: boolean) => {
            self.floors.forEach(element => {
                if (isPlus) {
                    element.plateArrow.count++
                } else {
                    if (element.plateArrow.count > 0){
                        element.plateArrow.count--
                    }
                }
            });
        },
        bulkUpdatePlateStairs: (isPlus: boolean) => {
            self.floors.forEach(element => {
                if (isPlus) {
                    element.plateStairs.count++
                } else {
                    if (element.plateStairs.count > 0) {
                        element.plateStairs.count--
                    }
                }
            });
        },
        bulkUpdatePlateNoSmiring: (isPlus: boolean) => {
            self.floors.forEach(element => {
                if (isPlus) {
                    element.plateNoSmiring.count++
                } else {
                    if (element.plateNoSmiring.count > 0) {
                        element.plateNoSmiring.count--
                    }
                }
            });
        },
        addFloor: () => {
            self.floors.unshift({
                flatsOnFloor: self.flatsOnFloors,
                flatNumberPlate: {
                    id: self.floors[0].flatNumberPlate.id,
                    name: self.floors[0].flatNumberPlate.name,
                    count: 1,
                    price: self.floors[0].flatNumberPlate.price
                },
                floorNumberPlate: {
                    id: self.floors[0].floorNumberPlate.id,
                    name: self.floors[0].floorNumberPlate.name,
                    number: 0,
                    count: 1,
                    price: self.floors[0].floorNumberPlate.price
                },
                flatsArraysPlate: {
                    id: "",
                    name: "",
                    withArray: false,
                    start: self.floors[0].flatsArraysPlate.end + 1,
                    end: self.floors[0].flatsArraysPlate.end + self.flatsOnFloors,
                    count: 1,
                    price: self.floors[0].flatsArraysPlate.price
                },
                plateExit: Plate.create({
                    id: self.floors[0].plateExit.id,
                    name: self.floors[0].plateExit.name,
                    count: 1,
                    price: self.floors[0].plateExit.price
                }),
                plateLift: Plate.create({
                    id: self.floors[0].plateLift.id,
                    name: self.floors[0].plateLift.name,
                    count: 1,
                    price: self.floors[0].plateLift.price
                }),
                plateLiftGruz: Plate.create({
                    id: self.floors[0].plateLiftGruz.id,
                    name: self.floors[0].plateLiftGruz.name,
                    count: 1,
                    price: self.floors[0].plateLiftGruz.price
                }),
                plateArrow: Plate.create({
                    id: self.floors[0].plateArrow.id,
                    name: self.floors[0].plateArrow.name,
                    count: 1,
                    price: self.floors[0].plateArrow.price
                }),
                plateStairs: Plate.create({
                    id: self.floors[0].plateStairs.id,
                    name: self.floors[0].plateStairs.name,
                    count: 1,
                    price: self.floors[0].plateStairs.price
                }),
                plateNoSmiring: Plate.create({
                    id: self.floors[0].plateNoSmiring.id,
                    name: self.floors[0].plateNoSmiring.name,
                    count: 1,
                    price: self.floors[0].plateNoSmiring.price
                })
            })
        },
        removeFloor: () => {
            if (self.floors.length > 1) {
                self.floors.shift()
            }
        },
        addFlatsOnFloor: () => {
            self.floors.reverse().forEach((floor, index, arr) => {
                if (floor.flatsOnFloor === self.flatsOnFloors) {
                    floor.flatsOnFloor++
                    if (index === 0) {
                        floor.flatsArraysPlate.end = floor.flatsOnFloor
                    } else {
                        floor.flatsArraysPlate.start = arr[index - 1].flatsArraysPlate.end + 1
                        floor.flatsArraysPlate.end = arr[index - 1].flatsArraysPlate.end + floor.flatsOnFloor
                    }
                }
            })
            self.flatsOnFloors++
        },
        removeFlatsOnFloor: () => {
            if (self.flatsOnFloors > 3) {
                self.floors.reverse().forEach((floor, index, arr) => {
                    if (floor.flatsOnFloor === self.flatsOnFloors) {
                        floor.flatsOnFloor--
                        if (index === 0) {
                            floor.flatsArraysPlate.end = floor.flatsOnFloor
                        } else {
                            floor.flatsArraysPlate.start = arr[index - 1].flatsArraysPlate.end + 1
                            floor.flatsArraysPlate.end = arr[index - 1].flatsArraysPlate.end + 1 + floor.flatsOnFloor
                        }
                    }
                })
                self.flatsOnFloors--
            }
        }
    }))

const HousePlates = types
    .model('HousePlates', {
        activeEntrance: 1,
        Entrances: types.array(Entrance),
        CountFlatsInEntrances: types.array(types.number)
    }).views(self => ({
        get getCountsOfFlats() {
            let countsOfFlats = [] as number[]
            let curentAddFlats = 0
            self.Entrances.forEach(element => {
                countsOfFlats.push(curentAddFlats)
                curentAddFlats += element.countOfFlats
            });
            return countsOfFlats
        },
        get fullPrice() {
            let result = 0
            self.Entrances.forEach(el => {
                result += el.priceEntrance
            })
            return result
        }
    })).actions(self => ({
        changePlatesCount: (entr: number, floorNumber: number, count: number) => {
            if (self.Entrances[entr].floors[floorNumber].flatsOnFloor > 1 || self.Entrances[entr].floors[floorNumber].flatsOnFloor < count) {
                self.Entrances[entr].floors[floorNumber].flatsOnFloor = count + 2
                self.Entrances[entr].floors[floorNumber].flatsArraysPlate.end = self.Entrances[entr].floors[floorNumber].flatsArraysPlate.start + count + 1
                for (let i = entr; i < self.Entrances.length; i++) {
                    if (i === entr) {
                        for (let j = floorNumber - 1; j >= 0; j--) {
                            if (self.Entrances[i].floors[j + 1]) {
                                self.Entrances[i].floors[j].flatsArraysPlate.start = self.Entrances[i].floors[j + 1].flatsArraysPlate.end + 1
                                self.Entrances[i].floors[j].flatsArraysPlate.end = self.Entrances[i].floors[j + 1].flatsArraysPlate.end + 1 + self.Entrances[i].floors[j].flatsOnFloor
                            }
                        }
                    } else {
                        for (let j = self.Entrances[i].floors.length - 1; j >= 0; j--) {
                            // if (j === self.Entrances[i].floors.length - 1 && i >0) {
                            //     self.Entrances[i]
                            // }
                            if (self.Entrances[i].floors[j + 1]) {
                                self.Entrances[i].floors[j].flatsArraysPlate.start = self.Entrances[i].floors[j + 1].flatsArraysPlate.end + 1
                                self.Entrances[i].floors[j].flatsArraysPlate.end = self.Entrances[i].floors[j + 1].flatsArraysPlate.end + 1 + self.Entrances[i].floors[j].flatsOnFloor
                            }
                        }
                    }
                }
            }
        }
    })).actions(self => ({
        addEntrance: () => {
            self.Entrances.push({
                flatsOnFloors: 3,
                floors: [{
                    flatsOnFloor: 3,
                    floorNumberPlate: {
                        id: self.Entrances[0].floors[0].floorNumberPlate.id,
                        name: self.Entrances[0].floors[0].floorNumberPlate.name,
                        number: 0,
                        count: 1,
                        price: self.Entrances[0].floors[0].floorNumberPlate.price,
                    },
                    flatNumberPlate: {
                        id: self.Entrances[0].floors[0].flatNumberPlate.id,
                        name: self.Entrances[0].floors[0].flatNumberPlate.name,
                        count: 1,
                        price: self.Entrances[0].floors[0].flatNumberPlate.price
                    },
                    flatsArraysPlate: {
                        id: "",
                        name: "",
                        withArray: false,
                        start: 1,
                        end: 3,
                        count: 1,
                        price: self.Entrances[0].floors[0].flatsArraysPlate.price
                    },
                    plateExit: Plate.create({
                        id: self.Entrances[0].floors[0].plateExit.id,
                        name: self.Entrances[0].floors[0].plateExit.name,
                        count: 1,
                        price: self.Entrances[0].floors[0].plateExit.price
                    }),
                    plateLift: Plate.create({
                        id: self.Entrances[0].floors[0].plateLift.id,
                        name: self.Entrances[0].floors[0].plateLift.name,
                        count: 1,
                        price: self.Entrances[0].floors[0].plateLift.price
                    }),
                    plateLiftGruz: Plate.create({
                        id: self.Entrances[0].floors[0].plateLiftGruz.id,
                        name: self.Entrances[0].floors[0].plateLiftGruz.name,
                        count: 1,
                        price: self.Entrances[0].floors[0].plateLiftGruz.price
                    }),
                    plateArrow: Plate.create({
                        id: self.Entrances[0].floors[0].plateArrow.id,
                        name: self.Entrances[0].floors[0].plateArrow.name,
                        count: 1,
                        price: self.Entrances[0].floors[0].plateArrow.price
                    }),
                    plateStairs: Plate.create({
                        id: self.Entrances[0].floors[0].plateStairs.id,
                        name: self.Entrances[0].floors[0].plateStairs.name,
                        count: 1,
                        price: self.Entrances[0].floors[0].plateStairs.price
                    }),
                    plateNoSmiring: Plate.create({
                        id: self.Entrances[0].floors[0].plateNoSmiring.id,
                        name: self.Entrances[0].floors[0].plateNoSmiring.name,
                        count: 1,
                        price: self.Entrances[0].floors[0].plateNoSmiring.price
                    })
                }],
                informationStandOne: {},
                informationStandTwo: {},
                informationStandTree: {},
                informationStandFour: {},
                informationStandFive: {},
                numberOnPostBox: {},
                conciergePlate: {},
                veloParkingPlate: {},
                buggyPlate: {},
                technicalRoomPlate: {},
                floorListPlate: {},
                cctvPlare: {}
            })
        },
        removeEnrance: () => {
            if (self.Entrances.length > 1) {
                self.Entrances.splice(-1, 1)
            }

        },
        changeActiveEntrance: (entr: number) => {
            self.activeEntrance = entr
        }
    })).actions(self => ({
        toBusket: () => {
            let entrs: Array<IPlate> = new Array
            self.Entrances.forEach((entrEl, entrNumber) => {
                entrs.push(BusketPlate.create({
                    img: entrEl.floors[0].floorNumberPlate.img,
                    id: entrEl.floors[0].floorNumberPlate.id as string,
                    name: entrEl.floors[0].floorNumberPlate.name,
                    randId: String(Math.round(new Date().getTime() / 1000)),
                    withArray: false,
                    midle: 0,
                    start: 0,
                    end: 0,
                    size: entrEl.floors[0].floorNumberPlate.size,
                    count: entrEl.floors.length,
                    price: entrEl.floors[0].floorNumberPlate.price,
                    entranceNumber: entrNumber
                }))
                entrs.push(BusketPlate.create({
                    img: entrEl.floors[0].flatsArraysPlate.img,
                    id: entrEl.floors[0].flatsArraysPlate.id as string,
                    name: entrEl.floors[0].flatsArraysPlate.name,
                    withArray: false,
                    randId: String(Math.round(new Date().getTime()/1000)),
                    midle: 0,
                    start: 0,
                    end: 0,
                    size: entrEl.floors[0].flatsArraysPlate.size,
                    count: entrEl.floors.length,
                    price: entrEl.floors[0].flatsArraysPlate.price,
                    entranceNumber: entrNumber
                }))
                entrs.push(BusketPlate.create({
                    img: entrEl.floors[0].flatNumberPlate.img,
                    id: entrEl.floors[0].flatNumberPlate.id as string,
                    name: entrEl.floors[0].flatNumberPlate.name,
                    withArray: false,
                    randId: String(Math.round(new Date().getTime()/1000)),
                    midle: 0,
                    start: 0,
                    end: 0,
                    size: entrEl.floors[0].flatNumberPlate.size,
                    count: entrEl.floors[0].flatsOnFloor * entrEl.floors.length,
                    price: entrEl.floors[0].flatNumberPlate.price,
                    entranceNumber: entrNumber
                }))
                entrs.push(BusketPlate.create({
                    img: entrEl.floors[0].plateExit.img,
                    id: entrEl.floors[0].plateExit.id as string,
                    name: entrEl.floors[0].plateExit.name,
                    withArray: false,
                    randId: String(Math.round(new Date().getTime()/1000)),
                    midle: 0,
                    start: 0,
                    end: 0,
                    size: entrEl.floors[0].plateExit.size,
                    count: entrEl.floors[0].plateExit.count * entrEl.floors.length,
                    price: entrEl.floors[0].plateExit.price,
                    entranceNumber: entrNumber
                }))
                entrs.push(BusketPlate.create({
                    img: entrEl.floors[0].plateLift.img,
                    id: entrEl.floors[0].plateLift.id as string,
                    name: entrEl.floors[0].plateLift.name,
                    withArray: false,
                    randId: String(Math.round(new Date().getTime()/1000)),
                    midle: 0,
                    start: 0,
                    end: 0,
                    size: entrEl.floors[0].plateLift.size,
                    count: entrEl.floors[0].plateLift.count * entrEl.floors.length,
                    price: entrEl.floors[0].plateLift.price,
                    entranceNumber: entrNumber
                }))
                entrs.push(BusketPlate.create({
                    img: entrEl.floors[0].plateLiftGruz.img,
                    id: entrEl.floors[0].plateLiftGruz.id as string,
                    name: entrEl.floors[0].plateLiftGruz.name,
                    withArray: false,
                    midle: 0,
                    randId: String(Math.round(new Date().getTime()/1000)),
                    start: 0,
                    end: 0,
                    size: entrEl.floors[0].plateLiftGruz.size,
                    count: entrEl.floors[0].plateLiftGruz.count * entrEl.floors.length,
                    price: entrEl.floors[0].plateLiftGruz.price,
                    entranceNumber: entrNumber
                }))
                entrs.push(BusketPlate.create({
                    img: entrEl.floors[0].plateArrow.img,
                    id: entrEl.floors[0].plateArrow.id as string,
                    name: entrEl.floors[0].plateArrow.name,
                    withArray: false,
                    randId: String(Math.round(new Date().getTime()/1000)),
                    midle: 0,
                    start: 0,
                    end: 0,
                    size: entrEl.floors[0].plateArrow.size,
                    count: entrEl.floors[0].plateArrow.count * entrEl.floors.length,
                    price: entrEl.floors[0].plateArrow.price,
                    entranceNumber: entrNumber
                }))
                entrs.push(BusketPlate.create({
                    img: entrEl.floors[0].plateStairs.img,
                    id: entrEl.floors[0].plateStairs.id as string,
                    name: entrEl.floors[0].plateStairs.name,
                    withArray: false,
                    randId: String(Math.round(new Date().getTime()/1000)),
                    midle: 0,
                    start: 0,
                    end: 0,
                    size: entrEl.floors[0].plateStairs.size,
                    count: entrEl.floors[0].plateStairs.count * entrEl.floors.length,
                    price: entrEl.floors[0].plateStairs.price,
                    entranceNumber: entrNumber
                }))
                entrs.push(BusketPlate.create({
                    img: entrEl.floors[0].plateNoSmiring.img,
                    id: entrEl.floors[0].plateNoSmiring.id as string,
                    name: entrEl.floors[0].plateNoSmiring.name,
                    withArray: false,
                    midle: 0,
                    randId: String(Math.round(new Date().getTime()/1000)),
                    start: 0,
                    end: 0,
                    size: entrEl.floors[0].plateNoSmiring.size,
                    count: entrEl.floors[0].plateNoSmiring.count * entrEl.floors.length,
                    price: entrEl.floors[0].plateNoSmiring.price,
                    entranceNumber: entrNumber
                }))
                if (entrEl.informationStandOne.count > 0) {
                    entrs.push(BusketPlate.create({
                        randId: String(Math.round(new Date().getTime()/1000)),
                        img: entrEl.informationStandOne.img,
                        id: entrEl.informationStandOne.id as string,
                        name: entrEl.informationStandOne.name,
                        size: entrEl.informationStandOne.size,
                        count: entrEl.informationStandOne.count,
                        price: entrEl.informationStandOne.price,
                        entranceNumber: entrNumber
                    }))
                }
                if (entrEl.informationStandTwo.count > 0) {
                    entrs.push(BusketPlate.create({
                        randId: String(Math.round(new Date().getTime()/1000)),
                        img: entrEl.informationStandTwo.img,
                        id: entrEl.informationStandTwo.id as string,
                        name: entrEl.informationStandTwo.name,
                        size: entrEl.informationStandTwo.size,
                        count: entrEl.informationStandTwo.count,
                        price: entrEl.informationStandTwo.price,
                        entranceNumber: entrNumber
                    }))
                }
                if (entrEl.informationStandTree.count > 0) {
                    entrs.push(BusketPlate.create({
                        randId: String(Math.round(new Date().getTime()/1000)),
                        img: entrEl.informationStandTree.img,
                        id: entrEl.informationStandTree.id as string,
                        name: entrEl.informationStandTree.name,
                        size: entrEl.informationStandTree.size,
                        count: entrEl.informationStandTree.count,
                        price: entrEl.informationStandTree.price,
                        entranceNumber: entrNumber
                    }))
                }
                if (entrEl.informationStandFour.count > 0) {
                    entrs.push(BusketPlate.create({
                        img: entrEl.informationStandFour.img,
                        id: entrEl.informationStandFour.id as string,
                        name: entrEl.informationStandFour.name,
                        size: entrEl.informationStandFour.size,
                        count: entrEl.informationStandFour.count,
                        price: entrEl.informationStandFour.price,
                        entranceNumber: entrNumber,
                        randId: ''
                    }))
                }
                if (entrEl.informationStandOne.count > 0) {
                    entrs.push(BusketPlate.create({
                        img: entrEl.informationStandFive.img,
                        id: entrEl.informationStandFive.id as string,
                        randId: '',
                        name: entrEl.informationStandFive.name,
                        size: entrEl.informationStandFive.size,
                        count: entrEl.informationStandFive.count,
                        price: entrEl.informationStandFive.price,
                        entranceNumber: entrNumber
                    }))
                }

            });
            (getRoot(self) as IStore).BusketStore.addConfiguratorToBusket(entrs)
            localStorage.setItem("configurator", JSON.stringify(getSnapshot(self)) as any)
            sessionStorage.setItem("configurator", JSON.stringify(getSnapshot(self)) as any)
            document.cookie = `configurator=${JSON.stringify(getSnapshot(self))}; path=/`
        }
    })).actions(self => ({
        afterCreate() {
            if (localStorage.getItem("configurator")) {
                applySnapshot(self, JSON.parse(localStorage.getItem("configurator") || house))
            }
            //applySnapshot(self, JSON.parse(house))
        }
    }))


export const ConfiguratorStore = types
    .model('ConfiguratorStoreStore', {
        housePlates: types.optional(HousePlates, {}),
    })

export interface IConfiguratorStore extends Instance<typeof ConfiguratorStore> { }
